import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function markMissionCompleted(missionToStaffId: number) {
  return restApiClient
    .url(constructApiUrl(API.missionToStaffs.markMissionCompleted.url, { id: missionToStaffId }))
    .post<MissionToStaff>()
}
